import { render } from "./App.vue?vue&type=template&id=0ced1ee4&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=0ced1ee4&lang=scss"

import exportComponent from "E:\\agent\\azdo\\CI\\a2-CI\\_work\\73\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__